import { FC } from "react";
import FixaButton from "../../shared/wrappers/FixaButton/FixaButton";
import { InsightsTablesType } from "../hooks/useInsightsData";
import ChevronLeftIconPath from "@coworker/apprestructured/src/shared/wrappers/FixaSSRIcon/paths/ChevronLeftIconPath";
import ChevronRightIconPath from "@coworker/apprestructured/src/shared/wrappers/FixaSSRIcon/paths/ChevronRightIconPath";
import styled from "styled-components";
import { Trans } from "@coworker/locales";
import { FixaSkeleton } from "../../shared/wrappers/FixaSkeleton/FixaSkeleton";

const Wrapper = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-top: 8px;
  font-size: 0.875rem;
`;

const ButtonContainer = styled.div`
  display: flex;
  gap: 8px;
`;

const LoadingText = styled.div`
  display: flex;
  gap: 4px;
  margin-top: 8px;
  font-size: 0.875rem;
`;

const InsightsTableNavigation: FC<{
  rowRange: {
    firstRowNumber: number;
    lastRowNumber: number;
  };
  totalRowCount: number;
  table: InsightsTablesType;
  handlePageNavigation: (
    table: InsightsTablesType,
    direction: "previous" | "next"
  ) => void;
  isLoading: boolean;
}> = ({ rowRange, totalRowCount, table, handlePageNavigation, isLoading }) =>
  isLoading ? (
    <LoadingText>
      <Trans>showingString</Trans>
      <FixaSkeleton width="100px" height={"20px"} />
    </LoadingText>
  ) : (
    <Wrapper>
      <Trans
        values={{
          firstRowNumber: rowRange.firstRowNumber,
          lastRowNumber: rowRange.lastRowNumber,
          totalRowCount: totalRowCount,
        }}
      >
        insightsTableRowRangeString
      </Trans>
      {totalRowCount > 5 && (
        <ButtonContainer>
          <FixaButton
            onClick={() => handlePageNavigation(table, "previous")}
            type="secondary"
            size="small"
            ssrIcon={ChevronLeftIconPath}
            iconOnly
            disabled={rowRange.firstRowNumber === 1}
          />
          <FixaButton
            onClick={() => handlePageNavigation(table, "next")}
            type="secondary"
            size="small"
            ssrIcon={ChevronRightIconPath}
            iconOnly
            disabled={rowRange.lastRowNumber === totalRowCount}
          />
        </ButtonContainer>
      )}
    </Wrapper>
  );

export default InsightsTableNavigation;
